import { IVisibleProp } from 'config'

export interface CollateralSection {
  id: number
  title: string
  fields: string[]
}

export interface CollateralReviewConfig {
  fields: Record<string, IVisibleProp>
  sections: CollateralSection[]
}

export const flattenConfig = (config: CollateralReviewConfig): Record<string, any> => {
  const result: Record<string, any> = {}
  const grouped = new Set(config.sections.flatMap((s) => s.fields))

  config.sections.forEach((section) => {
    result[`section_${section.id}`] = {
      inputType: 'section',
      title: section.title,
      span: 'full',
      _sectionId: section.id,
    }
    section.fields.forEach((key) => {
      if (config.fields[key]) result[key] = config.fields[key]
    })
  })

  Object.keys(config.fields).forEach((key) => {
    if (!grouped.has(key)) result[key] = config.fields[key]
  })

  return result
}
